import React, { useEffect, useState } from "react";
import { Checkbox, FormControlLabel, FormGroup, Grid, Paper, Tab, Tabs, TextField, Typography } from '@material-ui/core'
import ConfigData from '../../master/components/ConfigData'
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import EngineTypes from "../../engineTypes/pages";
import ApuTypes from "../../apuTypes/pages";
import SvEvents from "../../maintenancePrograms/pages/SvEvents";
import AircraftModels from "../../aircraftModels/pages";
import LgSubAssemblies from "../../lgSubAssemblies/pages";
import { Link } from "react-router";
import { globalGetService } from "../../../../globalServices";
import { checkApiStatus } from "../../../utils_v2";
import { PageLoader } from "../../../shared_elements";

const AircraftTypeView = () => {
    const [tabValue, setTabValue] = useState(0);
    const [aircraftTypesViewInfo, setAircraftTypesViewInfo] = useState({});
    const [isLoading, setLoading] = useState(false);
    

    useEffect(() => {
        getAircraftTypesView();
    },[])
    
    const FrontendUrl = window.location.pathname;
    const path = FrontendUrl.split('/');
    const id = path[path.length - 1];

    const getAircraftTypesView = (query) => {
        setLoading(true)
            globalGetService(`config-data/aircraft-type/${id}/`, query)
                .then(response => {
                    if (checkApiStatus(response)) {
                        setAircraftTypesViewInfo(response.data.data)
                    }
                    setLoading(false)
                })
        }

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <section className="asset-tech-specs" style={{ margin: '25px 0 0 75px' }}>
            <Paper elevation={0} className="tech-specs-card console-paper" style={{ height: `${window.innerHeight - 89}px` }}>
                <ConfigData />
                <div className="tech-specs-content">
                    <div style={{ display: "flex" , alignItems:'center', marginLeft: "8px" }}>
                        <Link to="/config-data/aircraftTypes/" fontSize="small" classname="back-icon" style={{ color:"#3f51b5" }}><ArrowBackIcon style={{ color: "#3f51b5", verticalAlign: 'top' }} /></Link>
                        <Typography variant="h7" >{aircraftTypesViewInfo?.name}</Typography>
                    </div>
                    <div className='console-management-modal' style={{padding:"0px 10px"}}>
                        <Grid container spacing={1}>
                            <Grid item md={2}>
                                <TextField
                                    name='no_of_engines'
                                    label='No. Of Engines'
                                    disabled
                                    value={aircraftTypesViewInfo?.no_of_engines || ''}
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={2}>
                                <TextField
                                    name='no_of_landing_gears'
                                    label='No. Of Landing Gear'
                                    disabled
                                    value={aircraftTypesViewInfo?.no_of_landing_gears || ''}
                                    fullWidth
                                    margin="normal"
                                    inputProps={{ maxLength: 1 }}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={4} >
                                <TextField
                                    name='aircraft_family'
                                    label='Aircraft Family'
                                    disabled
                                    value={aircraftTypesViewInfo?.aircraft_family?.name || ''}
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={4} >
                                <TextField
                                    name='aircraft_body_type'
                                    label='Aircraft Body Type'
                                    disabled
                                    value={aircraftTypesViewInfo?.aircraft_body_type?.label || ''}
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={12} >
                                <TextField
                                    name='remarks'
                                    label='Remarks'
                                    disabled
                                    value={aircraftTypesViewInfo?.remarks || ''}
                                    fullWidth
                                    multiline
                                    rows={3}
                                    margin="normal"
                                    inputProps={{ maxLength: 255 }}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={4}>
                                <FormGroup row style={{ justifyContent: "space-between", }}>
                                    <FormControlLabel
                                        control={<Checkbox checked={aircraftTypesViewInfo?.has_propeller===true} disabled name="hasPropeller" color="primary" size="small" />}
                                        label="Has Propeller"
                                    />
                                    <FormControlLabel
                                        control={<Checkbox checked={aircraftTypesViewInfo?.has_apu===true} disabled name="hasApu" color="primary" size="small" />}
                                        label="Has APU"
                                    />
                                </FormGroup>
                            </Grid>
                        </Grid>
                    </div>
                    <div square style={{ padding: '4px 10px' }}>
                            <Paper elevation={0} className="console-paper">
                            <Tabs
                                value={tabValue}
                                onChange={handleTabChange}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="fullWidth"
                            >
                                <Tab label="Engine Type's" />
                                <Tab label="APU Type's" />
                                <Tab label="Maintenance Program" />
                                <Tab label="Aircraft Model" />
                                <Tab label="LG Sub Assembly" />
                            </Tabs>
                            </Paper>
                            {tabValue === 0 && <EngineTypes isEngine={true} aircraftTypeName={aircraftTypesViewInfo?.name || ''} deleted={aircraftTypesViewInfo.deleted_at}/>}
                            {tabValue === 1 && <ApuTypes isApuTypes={true} aircraftTypeName={aircraftTypesViewInfo?.name || ''} deleted={aircraftTypesViewInfo.deleted_at}/>}
                            {tabValue === 2 && <SvEvents isSvEvents={true} aircraftTypeName={aircraftTypesViewInfo?.name || ''} deleted={aircraftTypesViewInfo.deleted_at}/>}
                            {tabValue === 3 && <AircraftModels isModel={true} aircraftTypeName={aircraftTypesViewInfo?.name || ''} deleted={aircraftTypesViewInfo.deleted_at}/>}
                            {tabValue === 4 && <LgSubAssemblies isLgSubAssembly={true} aircraftTypeName={aircraftTypesViewInfo?.name || ''} deleted={aircraftTypesViewInfo.deleted_at}/>}
                        </div>
                </div>
            </Paper>
            {isLoading?<PageLoader/>:null}
        </section>
    )
}

export default AircraftTypeView